
import axios from "axios";

export const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BLOG_API_URL,
});

export const getAllNews = async (page = 1, searchQuery = "", categoryId) => {
    try {
        const searchFilter = searchQuery
            ? `&filters[title][$containsi]=${searchQuery}`
            : "";

        const response = await api.get(
            categoryId ? `api/news?populate=*&filters[categories]=${categoryId}&pagination[page]=${page}&pagination[pageSize]=${process.env.NEXT_PUBLIC_NEWS_PAGE_LIMIT}${searchFilter}` : `api/news?populate=*&pagination[page]=${page}&pagination[pageSize]=${process.env.NEXT_PUBLIC_NEWS_PAGE_LIMIT}${searchFilter}`
        );

        return {
            posts: response.data.data,
            pagination: response.data.meta.pagination,
        };
    } catch (error) {
        console.error("Error fetching blogs:", error);
        throw new Error("Server error");
    }
};

export const getPostsByCategory = async (categoryId, page = 1, pageSize = 10) => {
    try {
        const response = await api.get(
            `api/blogs?filters[category]=${categoryId}&pagination[page]=${page}&pageSize=${process.env.NEXT_PUBLIC_PAGE_LIMIT}`
        );
        return {
            posts: response.data.data,
            pagination: response.data.meta.pagination,
        };
    } catch (error) {
        console.error("Error fetching posts by category:", error);
        throw new Error("Server error");
    }
};

export const getPostBySlug = async (slug) => {
    try {
        const response = await api.get(`api/blogs?filters[slug]=${slug}&populate=*`);

        if (response.data.data.length > 0) {
            return response.data.data[0];
        }
        throw new Error("Post not found.");
    } catch (error) {
        console.error("Error fetching post:", error);
        throw new Error("Server error");
    }
};

export const getAllCategories = async () => {
    try {
        const response = await api.get("api/categories?populate=*");
        return {categories: response.data.data};
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw new Error("Server error");
    }
};